import {
  IHealthPointTransactionExtendedData,
  isHealthPointTransactionExtendedData,
  TransactionStatus,
} from '@principle-theorem/principle-core/interfaces';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { GeneralProviderActionsService } from '../../../general-provider-actions.service';
import {
  ITransactionAction,
  ITransactionActionsData,
} from '../../../transaction-action';
import { TransactionHelpers } from '../../../transaction-helpers';

export class ApproveHealthPointTransaction
  implements ITransactionAction<IHealthPointTransactionExtendedData>
{
  icon = 'done';
  label = 'Approve';
  inProgress$ = new BehaviorSubject<boolean>(false);
  typeGuardFn = isHealthPointTransactionExtendedData;

  constructor(private _actions: GeneralProviderActionsService) {}

  canDo$(
    data: ITransactionActionsData<IHealthPointTransactionExtendedData>
  ): Observable<boolean> {
    return TransactionHelpers.lastTransaction$(
      data,
      isHealthPointTransactionExtendedData
    ).pipe(
      map((transaction) => {
        if (!transaction) {
          return false;
        }
        return transaction.status === TransactionStatus.Pending;
      })
    );
  }

  async do(
    data: ITransactionActionsData<IHealthPointTransactionExtendedData>
  ): Promise<void> {
    this.inProgress$.next(true);
    try {
      await this._actions.approve(
        data.invoice,
        data.latestTransaction,
        'Approve HealthPoint Transaction'
      );
    } finally {
      this.inProgress$.next(false);
    }
  }
}
